import request from '@/utils/request'


// 创建质疑
export const createComplain = (complaintType, data) => {
    return request.post(`/api/agent/${complaintType}/complain/create`, data)
}
//质疑列表
export const getComplainList = (complaintType, data) => {
    return request.get(`/api/agent/${complaintType}/complain/list?complaintType=`+data.complaintType+'&projectCode='+data.projectCode+'&pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&stage='+data.stage)
}
//质疑详情
export const getComplainDetail = (complaintType, data) => {
    return request.get(`/api/agent/${complaintType}/complain/detail?complaintType=`+complaintType+'&complaintCode='+data.complaintCode)
}
//质疑回复
export const submitComplainReply = (complaintType, data) => {
    return request.post(`/api/agent/${complaintType}/complain/reply`, data)
}
